import { useRewardsStore } from "../stores/rewardsStore";
import { claimMilestone, claimReferral } from "../api/rewards/api";

export const useRewardsData = () => {
  const {
    referralStats,
    milestoneStatus,
    xpBalance,
    fetchReferralStats,
    fetchMilestoneStatus,
    fetchXPBalance,
  } = useRewardsStore();

  return {
    // API States
    referralStats,
    milestoneStatus,
    xpBalance,

    // Computed loading state
    isLoading:
      referralStats.isLoading ||
      milestoneStatus.isLoading ||
      xpBalance.isLoading,

    // Computed error state
    hasError: !!(
      referralStats.error ||
      milestoneStatus.error ||
      xpBalance.error
    ),

    // Actions
    claimMilestone,
    claimReferral,
    refreshReferralStats: fetchReferralStats,
    refreshMilestoneStatus: fetchMilestoneStatus,
    refreshXPBalance: fetchXPBalance,
  };
};
